<template>
  <modal>
    <h2 class="font-bold">Feedback verstuurd!</h2>
    <p>Je feedback houdt ons scherp, dankjewel!</p>
  </modal>
</template>
<script lang="ts" setup>
import Modal from '@app/components/Modal.vue';
</script>
<style lang="scss">
</style>
